import Bus from "../bus/bus";

export type IsockMessage = {
    id: string | number;
    action: string;
    payload: string | number | object | any;
    created: Date | string | null;
    status?: number;
};

export type IsockMessageProxyCallPayload = {
    url: string;
    data: object | string | any;
    headers: object | null;
    method: string;
    axiosOptions?: object;
};

export type IsockMessageGetFeaturePayload = {
    featureId: string;
};

export type MessageHandler = (msg: IsockMessage) => void;

export const ISOCK_ACTION_READY = "IframeSocket::ACTION::READY";
export const ISOCK_ACTION_CONNECT = "IframeSocket::ACTION::CONNECT";
export const ISOCK_ACTION_MESSAGE_RECEIVED = "IframeSocket::ACTION::MESSAGE_RECEIVED";
export const ISOCK_ACTION_EVENT_RECEIVED = "IframeSocket::ACTION::EVENT_RECEIVED";

class IframeSocket {

    name: string = 'default';
    port: MessagePort;
    bus: Bus<IsockMessage>;

    constructor(port: MessagePort, name: string = 'default') {
        this.name = name;
        this.port = port;
        this.bus = new Bus<IsockMessage>();
        this.port.onmessage = this.onMessage.bind(this);
    }

    public on(action: string, handler: MessageHandler) {
        this.bus.on(action, handler);
    }

    public off(action: string, handler?: MessageHandler) {
        this.bus.off(action, handler);
    }

    public send(msg: IsockMessage) {
        this.port.postMessage(JSON.stringify(msg));
    }

    public destroy() {
        this.bus.clear();
        this.port.close();
    }

    protected onMessage(e: MessageEvent) {
        try {
            const msg = JSON.parse(e.data) as IsockMessage;
            this.trigger(msg.action, msg);
        } catch(e) {
            console.log(this.name + " received invalid message:" + e.message, e);
            return;
        }
    }

    protected trigger(action: string, msg: IsockMessage) {
        //handle the possible IPM_ACTION_MESSAGE_RECEIVED hooks for any message
        this.bus.trigger(ISOCK_ACTION_MESSAGE_RECEIVED, msg);
        this.bus.trigger(action, msg);
    }
}

export default IframeSocket;
